import React from "react";
import { BsBookmarkPlus, BsCollectionPlay } from "react-icons/bs";
import { CgMenuBoxed } from "react-icons/cg";
import { MdContactPhone } from "react-icons/md";
import { FcAbout } from "react-icons/fc";
import { NavLink } from "react-router-dom";
import useAuthContext from "../../components/AuthContext/AuthContext";

const MobileFooter = () => {
  const { show, setShow, cart } = useAuthContext();

  const handleCartShow = (e) => {
    e.preventDefault();
    setShow(!show);
  };

  const active = "bg-white text-main";
  const inActive =
    "transitions text-2xl flex-colo hover:bg-white hover:text-main text-white rounded-md px-4 py-3";
  const Hover = ({ isActive }) =>
    isActive ? `${active} ${inActive}` : inActive;
  return (
    <div>
      <div className="flex-btn cursor-pointer bg-white rounded h-full overflow-y-scroll flex-grow">
        {/* {Drawer} */}
      </div>

      <footer className="lg:hidden fixed z-50 bottom-0 w-full px-1">
        <div className="bg-dry rounded-md flex justify-between mx-2 items-center w-full p-1">
          <NavLink to="/movies" className={Hover}>
            <BsCollectionPlay className="text-red-600" />
          </NavLink>
          <NavLink to="/contact-us" className={Hover}>
            <MdContactPhone className="text-red-600" />
          </NavLink>
          <NavLink to="/about-us" className={Hover}>
            <FcAbout className="text-red-600 bg-red-600" />
          </NavLink>
          <button onClick={handleCartShow} className={Hover}>
            <div className="relative">
              <BsBookmarkPlus className="flex text-red-600 w-6 h-6 font-bold " />
              <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-slate-100 flex justify-center items-center text-[0.65rem] text-slate-900">
                {cart.length}
              </span>
            </div>
          </button>
          <button className={inActive}>
            <CgMenuBoxed className="text-red-600" />
          </button>
        </div>
      </footer>
    </div>
  );
};

export default MobileFooter;
